// useUIState.js - UI navigation and dialog state management
import { useState } from 'react';
import { readWorkspaceUrlState } from '../utils/builderUrlState';

export const useUIState = () => {
  // Navigation state
  const [currentStep, setCurrentStep] = useState(0);
  const [activeTab, setActiveTab] = useState(() => readWorkspaceUrlState().tab);

  // Modal and dialog states
  const [showDraftManager, setShowDraftManager] = useState(false);
  const [showDraftSaveDialog, setShowDraftSaveDialog] = useState(false);
  const [showLoadModal, setShowLoadModal] = useState(false);
  const [showPOIForm, setShowPOIForm] = useState(false);
  const [showContextPanel, setShowContextPanel] = useState(false);
  const [showBatchAudio, setShowBatchAudio] = useState(false);
  const [showTranslation, setShowTranslation] = useState(false);
  const [showPrompts, setShowPrompts] = useState(false);
  const [showUrlDialog, setShowUrlDialog] = useState(false);
  const [showSqlDialog, setShowSqlDialog] = useState(false);
  const [showPermissionManager, setShowPermissionManager] = useState(false);
  const [showQADialog, setShowQADialog] = useState(false);

  // Loading states
  const [isLoading, setIsLoading] = useState(false);
  const [loadProgress, setLoadProgress] = useState(0);
  const [isGeneratingAudio, setIsGeneratingAudio] = useState(false);
  const [copied, setCopied] = useState(false);
  const [executing, setExecuting] = useState(false);
  const [executionResult, setExecutionResult] = useState(null);

  // Helper functions for common UI operations
  const closeAllDialogs = () => {
    setShowDraftManager(false);
    setShowDraftSaveDialog(false);
    setShowLoadModal(false);
    setShowPOIForm(false);
    setShowContextPanel(false);
    setShowBatchAudio(false);
    setShowTranslation(false);
    setShowPrompts(false);
    setShowUrlDialog(false);
    setShowSqlDialog(false);
    setShowPermissionManager(false);
    setShowQADialog(false);
  };

  const resetUIState = () => {
    setCurrentStep(0);
    setActiveTab('metadata');
    closeAllDialogs();
    setIsLoading(false);
    setLoadProgress(0);
    setIsGeneratingAudio(false);
    setCopied(false);
    setExecuting(false);
    setExecutionResult(null);
  };

  // Navigation helpers
  const navigateToStep = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  const navigateToTab = (tabName) => {
    setActiveTab(tabName);
  };

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const previousStep = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  return {
    // Navigation state
    currentStep,
    setCurrentStep,
    activeTab,
    setActiveTab,

    // Modal states
    showDraftManager,
    setShowDraftManager,
    showDraftSaveDialog,
    setShowDraftSaveDialog,
    showLoadModal,
    setShowLoadModal,
    showPOIForm,
    setShowPOIForm,
    showContextPanel,
    setShowContextPanel,
    showBatchAudio,
    setShowBatchAudio,
    showTranslation,
    setShowTranslation,
    showPrompts,
    setShowPrompts,
    showUrlDialog,
    setShowUrlDialog,
    showSqlDialog,
    setShowSqlDialog,
    showPermissionManager,
    setShowPermissionManager,
    showQADialog,
    setShowQADialog,

    // Loading states
    isLoading,
    setIsLoading,
    loadProgress,
    setLoadProgress,
    isGeneratingAudio,
    setIsGeneratingAudio,
    copied,
    setCopied,
    executing,
    setExecuting,
    executionResult,
    setExecutionResult,

    // Helper functions
    closeAllDialogs,
    resetUIState,
    navigateToStep,
    navigateToTab,
    nextStep,
    previousStep
  };
};
